import {
  ChangeDetectionStrategy,
  Component,
  inject,
  AfterContentInit,
  OnDestroy
} from '@angular/core';
import { SubscriberAdvertiserModule } from '../../subscriber-advertiser.module';
import { BaseSubscriberAdvertiserComponent } from '../../abstract-components/base-subscriber-advertiser.component';
import { filter, tap } from 'rxjs';
import { PageEvent } from '@angular/material/paginator';
import { EventService } from '~app/app/~shared/services/event.service';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { GlobalEvent } from '~core/models/shared.models';

@Component({
  selector: 'subscriber-advertiser-list-page',
  standalone: true,
  imports: [SubscriberAdvertiserModule],
  templateUrl: './subscriber-advertiser-list-page.component.html',
  styleUrl: './subscriber-advertiser-list-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriberAdvertiserListPageComponent
  extends BaseSubscriberAdvertiserComponent
  implements AfterContentInit, OnDestroy
{
  private _resourceFacade = inject(ResourceFacade);
  private _eventService = inject(EventService);

  resources$ = this._resourceFacade.resources$;
  currentError$ = this._resourceFacade.currentError$;
  paginationData$ = this._resourceFacade.paginationData$;
  isLoading$ = this._resourceFacade.isLoading$;

  onGlobalRefresh$ = this._eventService.events$.pipe(
    filter((ev: GlobalEvent) => ev.type === 'REFRESH_DATA'),
    tap(() => this.refreshData())
  );

  ngAfterContentInit(): void {
    this._resourceFacade.getData();
  }

  ngOnDestroy(): void {
    this._resourceFacade.resetState();
  }

  refreshData(): void {
    this._resourceFacade.getData({ refresh: true });
  }

  handlePageEvent(e: PageEvent): void {
    this._resourceFacade.setPagination({
      ...(e.pageSize && { itemPerPage: e.pageSize }),
      page: e.pageIndex + 1 || 1
    });
  }

  onSearch(searchText: string | null): void {
    this._resourceFacade.applyFilters({
      name: searchText ? `like(%${searchText}%)` : null
    });
    this._resourceFacade.getData({ refresh: true });
  }
}
